module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-86.447a1c3e.svg";